<template>
	<div class="home flex start-v">
		<div class="tabs flex around">
			<span @click="currentTab=0" :class="{'active':currentTab===0}">跑步锻炼</span>
			<span @click="currentTab=1" :class="{'active':currentTab===1}">AI运动</span>
		</div>

		<div class="contain">
			<InfoRun v-if="currentTab===0" :currentTab="currentTab"/>
			<InfoAi v-if="currentTab===1" :currentTab="currentTab"/>
		</div>
	</div>
</template>

<script>
import InfoRun from "./child/infoRun.vue";
import InfoAi from "./child/infoAi.vue";
export default {
	components:{InfoRun,InfoAi},
	data() {
		return {
			currentTab: 0,
		};
	},
};
</script>

<style scoped lang="less">
.home {
	height: 100%;
	padding: 17 / @rem 0 0;
	.tabs {
		width: 100%;
		padding-bottom: 24 / @rem;
		font-size: 17 / @rem;
		font-weight: bold;
		color: rgba(31, 30, 29, 0.3);
		span {
			position: relative;
			&.active {
				color: rgba(31, 30, 29, 1);
				&::before {
					content: "";
					display: block;
					width: 72 / @rem;
					height: 8 / @rem;
					border-radius: 5 / @rem;
					background: linear-gradient(
						270deg,
						#ffffff 0%,
						#ffa216 100%
					);
					position: absolute;
					bottom: -10 / @rem;
					left: 0 / @rem;
				}
			}
		}
	}

	.contain {
		flex: 1;
		width: 100%;
		border-radius: 21 / @rem 21 / @rem 0 0;
		overflow: hidden;
	}
}
</style>
